export var EDay;
(function (EDay) {
  EDay["Monday"] = "Monday";
  EDay["Tuesday"] = "Tuesday";
  EDay["Wednesday"] = "Wednesday";
  EDay["Thursday"] = "Thursday";
  EDay["Friday"] = "Friday";
  EDay["Saturday"] = "Saturday";
  EDay["Sunday"] = "Sunday";
})(EDay || (EDay = {}));